<template>
    <form>
        <b-form-group label-cols="3" label="First Name:" label-for="firstName">
            <b-input
                id="firstName"
                name="firstName"
                placeholder="First Name (required)"
                v-model="state.firstName"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('firstName') }"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Last Name:" label-for="lastName">
            <b-input
                id="lastName"
                name="lastName"
                placeholder="Last Name (required)"
                v-model="state.lastName"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('lastName') }"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Address:" label-for="address">
            <b-input
                id="address"
                name="address"
                placeholder="Address (optional)"
                v-model="state.address"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Zipcode:" label-for="zipcode">
            <b-input
                id="zipcode"
                name="zipcode"
                placeholder="Zipcode (optional)"
                v-model="state.zipcode"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="City:" label-for="city">
            <b-input
                id="city"
                name="city"
                placeholder="City (optional)"
                v-model="state.city"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="State:" label-for="state">
            <b-input
                id="state"
                name="state"
                placeholder="State (optional)"
                v-model="state.state"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Country:" label-for="country">
            <b-input
                id="country"
                name="country"
                placeholder="Country (optional)"
                v-model="state.country"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Birthdate:" label-for="birthdate">
            <date-picker
                name="birthDate"
                :config="datePickerBirthOptions"
                v-model="state.birthDate"
                placeholder="Birth Date (optional)"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Email:" label-for="email">
            <b-input
                id="email"
                name="email"
                placeholder="Email (optional)"
                v-model="state.email"
            />
            <contact-warning
                :type="CLIENT.CONTACT_DETAIL_TYPES.EMAIL"
                :value="state.email"
                :contacts="contacts"
            />
        </b-form-group>
        <b-form-group
            label-cols="3"
            label="Driver License:"
            label-for="driverLicense"
        >
            <b-input
                id="driverLicense"
                name="driverLicense"
                placeholder="Driver License (optional)"
                v-model="state.driverLicense"
            />
        </b-form-group>
        <b-form-group label-cols="3" label="Home:" label-for="home">
            <div class="row">
                <div class="col-4">
                    <CountryCode
                        v-model="state.phone.home.countryCode"
                        :defaultValue="$root.setting.phone_code"
                        class="form-control"
                    />
                </div>
                <div class="col pl-0">
                    <b-input
                        id="home"
                        name="home"
                        placeholder="Home Phone (optional)"
                        v-model="state.phone.home.number"
                    />
                </div>
                <contact-warning
                    class="col-sm-12"
                    :type="CLIENT.CONTACT_DETAIL_TYPES.HOME"
                    :value="state.phone.home.number"
                    :contacts="contacts"
                />
            </div>
        </b-form-group>
        <b-form-group label-cols="3" label="Mobile:" label-for="mobile">
            <div class="row">
                <div class="col-4">
                    <CountryCode
                        v-model="state.phone.mobile.countryCode"
                        :defaultValue="$root.setting.phone_code"
                        class="form-control"
                    />
                </div>
                <div class="col pl-0">
                    <b-input
                        id="mobile"
                        name="mobile"
                        placeholder="Mobile Phone (optional)"
                        v-model="state.phone.mobile.number"
                    />
                </div>
                <contact-warning
                    class="col-sm-12"
                    :type="CLIENT.CONTACT_DETAIL_TYPES.MOBILE"
                    :value="state.phone.mobile.number"
                    :contacts="contacts"
                />
            </div>
        </b-form-group>
        <b-form-group label-cols="3" label="Work:" label-for="work">
            <div class="row">
                <div class="col-4">
                    <CountryCode
                        v-model="state.phone.work.countryCode"
                        :defaultValue="$root.setting.phone_code"
                        class="form-control"
                    />
                </div>
                <div class="col pl-0">
                    <b-input
                        id="work"
                        name="work"
                        placeholder="Work Phone (optional)"
                        v-model="state.phone.work.number"
                    />
                </div>
                <contact-warning
                    class="col-sm-12"
                    :type="CLIENT.CONTACT_DETAIL_TYPES.WORK"
                    :value="state.phone.work.number"
                    :contacts="contacts"
                />
            </div>
        </b-form-group>
        <b-form-group label-cols="3" label="Fax:" label-for="fax">
            <div class="row">
                <div class="col-4">
                    <CountryCode
                        v-model="state.phone.fax.countryCode"
                        :defaultValue="$root.setting.phone_code"
                        class="form-control"
                    />
                </div>
                <div class="col pl-0">
                    <b-input
                        id="fax"
                        name="fax"
                        placeholder="Fax Phone (optional)"
                        v-model="state.phone.fax.number"
                    />
                </div>
                <contact-warning
                    class="col-sm-12"
                    :type="CLIENT.CONTACT_DETAIL_TYPES.FAX"
                    :value="state.phone.fax.number"
                    :contacts="contacts"
                />
            </div>
        </b-form-group>
        <b-form-group label-cols="3" label="Reminders:" label-for="reminders">
            <v-select
                id="reminders"
                v-model="selectedReminders"
                placeholder="Reminder Option (optional)"
                multiple
                :options="reminderOptions"
            />
        </b-form-group>
    </form>
</template>

<script>
import vSelect from "vue-select";
import CountryCode from "@/module/commons/countrycode.vue";
import ContactWarning from "@/components/commons/client-contact-field-warning";
import ClientContactDetailMixin from "@/mixins/client-contact-details";

import CLIENT from "@/constants/clients";

const reminderNames = {
    EMAIL: "Email",
    SMS: "SMS (Text)",
    MAIL: "Mail",
    PHONE: "Phone"
};

export default {
    mixins: [ClientContactDetailMixin],
    components: {
        CountryCode,
        vSelect,
        ContactWarning
    },
    data() {
        return {
            reminderOptionsArray: [],
            datePickerBirthOptions: {},
            contacts: [],
            CLIENT
        };
    },
    computed: {
        reminderOptions() {
            let selected = this.state.reminders || []; // eg. [2,3,4]
            let arr = [...this.availableReminders()];

            for (let reminderId of selected) {
                arr = arr.filter(r => r.id !== reminderId);
            }

            return arr;
        },
        selectedReminders: {
            get() {
                let raw = this.state.reminders || []; // eg. [2,3,4]
                let arr = [];

                for (let type in this.REMINDER_TYPE) {
                    let id = this.REMINDER_TYPE[type];

                    if (raw.includes(id)) {
                        arr.push({
                            id: id,
                            label: reminderNames[type]
                        });
                    }
                }
                return arr;
            },
            set(values = []) {
                let arr = [];
                for (let reminder of values) {
                    arr.push(reminder.id);
                }

                // update form state, including reminders, thus it will reflect the UI
                this.state = {
                    ...this.state,
                    reminders: arr
                };
            }
        },
        state: {
            get() {
                return this.$store.state.modalReservation.view.CLIENT_INFORMATION; // prettier-ignore
            },
            set(value) {
                this.$store.commit("modalReservation/setViewState", {
                    view: "CLIENT_INFORMATION",
                    value: value
                });
            }
        },
        selectedClientId() {
            return this.$store.state.modalReservation.view.RESERVATION
                .selectedClient.id;
        }
    },
    watch: {
        "state.email"(value) {
            this.setReminderOption(this.REMINDER_TYPE.EMAIL);
        },
        "state.phone.home.number"(value) {
            this.setReminderOption(this.REMINDER_TYPE.PHONE);
        },
        "state.phone.mobile.number"(value) {
            this.setReminderOption(this.REMINDER_TYPE.PHONE);
            this.setReminderOption(this.REMINDER_TYPE.SMS);
        },
        "state.phone.work.number"(value) {
            this.setReminderOption(this.REMINDER_TYPE.PHONE);
        },
        "state.address"(value) {
            this.setReminderOption(this.REMINDER_TYPE.MAIL);
        }
    },
    mounted() {
        this.datePickerBirthOptions = {
            format: this.getDateFormat()
        };

        this.getContactDetails(this.selectedClientId).then(contacts => {
            this.contacts = contacts;
        });
    },
    methods: {
        availableReminders() {
            let { phone, email, address, city, state, zipcode } = this.state;
            let { home, mobile, work } = phone;
            let arr = [];
            let ref = this.REMINDER_TYPE;

            let hasEmail =
                (email && email !== "") ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.EMAIL,
                    this.contacts
                );
            let hasHomeNumber =
                (home && home.number !== "") ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.HOME,
                    this.contacts
                );
            let hasWorkNumber =
                (work && work.number !== "") ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.WORK,
                    this.contacts
                );
            let hasMobileNumber =
                (mobile && mobile.number !== "") ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                    this.contacts
                );
            let hasAddress = address && city && state && zipcode;

            let isEnableSMSExtension =
                this._isExtensionEnabled("SMS") ||
                this._isExtensionEnabled("2_WAY_MESSAGING");

            if (hasMobileNumber & isEnableSMSExtension) {
                arr.push({
                    id: ref.SMS,
                    label: reminderNames.SMS
                });
            }
            if (hasMobileNumber || hasHomeNumber || hasWorkNumber) {
                arr.push({
                    id: ref.PHONE,
                    label: reminderNames.PHONE
                });
            }
            if (hasEmail) {
                arr.push({
                    id: ref.EMAIL,
                    label: reminderNames.EMAIL
                });
            }
            if (hasAddress) {
                arr.push({
                    id: ref.MAIL,
                    label: reminderNames.MAIL
                });
            }

            return arr;
        },
        setReminderOption(type) {
            let ref = this.REMINDER_TYPE;

            let { phone, email, address, city, state, zipcode } = this.state;
            let { home, mobile, work } = phone;

            let isPopulateReminders = null;

            switch (type) {
                case ref.EMAIL: {
                    let hasEmail =
                        (email && email !== "") ||
                        this.checkContactTypeHasNextPrimary(
                            CLIENT.CONTACT_DETAIL_TYPES.EMAIL,
                            this.contacts
                        );

                    isPopulateReminders = hasEmail;
                    break;
                }

                case ref.PHONE: {
                    let hasHomeNumber =
                        (home && home.number !== "") ||
                        this.checkContactTypeHasNextPrimary(
                            CLIENT.CONTACT_DETAIL_TYPES.HOME,
                            this.contacts
                        );
                    let hasWorkNumber =
                        (work && work.number !== "") ||
                        this.checkContactTypeHasNextPrimary(
                            CLIENT.CONTACT_DETAIL_TYPES.WORK,
                            this.contacts
                        );
                    let hasMobileNumber =
                        (mobile && mobile.number !== "") ||
                        this.checkContactTypeHasNextPrimary(
                            CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                            this.contacts
                        );

                    isPopulateReminders =
                        hasHomeNumber || hasWorkNumber || hasMobileNumber;
                    break;
                }

                case ref.SMS: {
                    let hasMobileNumber =
                        (mobile && mobile.number !== "") ||
                        this.checkContactTypeHasNextPrimary(
                            CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                            this.contacts
                        );

                    let isEnableSMSExtension =
                        this._isExtensionEnabled("SMS") ||
                        this._isExtensionEnabled("2_WAY_MESSAGING");

                    isPopulateReminders =
                        hasMobileNumber && isEnableSMSExtension;
                    break;
                }

                case ref.MAIL: {
                    let hasAddress = address && city && state && zipcode;

                    isPopulateReminders = hasAddress;
                    break;
                }
            }

            if (isPopulateReminders == null) {
                return;
            }

            const selectedReminder = this.selectedReminders.find(
                reminder => reminder.id === type
            );

            if (isPopulateReminders && !selectedReminder) {
                this.selectedReminders.push({
                    id: type,
                    label: reminderNames[type]
                });
            } else if (!isPopulateReminders && selectedReminder) {
                this.selectedReminders = this.selectedReminders.filter(
                    reminder => reminder.id !== type
                );
            }
        }
    }
};
</script>
